// import { DndContext } from "@dnd-kit/core";
// import {
//   SortableContext,
//   rectSortingStrategy,
//   arrayMove,
// } from "@dnd-kit/sortable";
// import { useState } from "react";

// import Draggable from "../helpers/Draggable";
// import Droppable from "../helpers/Droppable";
// import SortableItem from "../helpers/SortableItem";
// import FieldBlock from "../helpers/FieldBlock";
// import ContainerBlock from "../helpers/ContainerBlock";
// import { initialItems } from "../helpers/initialItems";
// import { Button, Card, Col, Row } from "react-bootstrap";
// import BreadCrumbTable from "../../../../components/breadcrumb/BreadCrumbTable";
// import { toast } from "react-toastify";
// import { customSettings } from "utils/customConfig";
// import { useForm } from "react-hook-form";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import * as yup from "yup";
// import { yupResolver } from "@hookform/resolvers/yup";
// import BlockEditModal from "../modal/BlockEditModal";
// import MarqueeMessageModal from "../modal/MarqueeMessageModal";

// // const schema = yup.object().shape({
// //   name: yup.string().required("Name is required"),
// //   sortOrder: yup.string().required("Display order is required"),
// //   fields: yup.array().of(
// //     yup.object().shape({
// //       key: yup.string().required(),
// //       type: yup.string().required(),
// //       properties: yup.object().shape({
// //         label: yup.string(),
// //         placeholder: yup.string(),
// //         required: yup.boolean(),
// //         readOnly: yup.boolean(),
// //         counter: yup.boolean(),
// //       }),
// //     }),
// //   ),
// //   status: yup.boolean(),
// // });

// const PageBuilder = () => {
//   const submittedValues = {};
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     control,
//     clearErrors,
//     getValues,
//     reset,
//     setValue,
//     trigger,
//     watch,
//   } = useForm({
//     defaultValues: {},
//     // resolver: yupResolver(schema),
//     shouldUnregister: true,
//   });
//   const navigate = useNavigate();
//   const { state } = useLocation();

//   const [blocks, setBlocks] = useState([]);
//   const [editingBlock, setEditingBlock] = useState(null);

//   const openEditModal = (block) => setEditingBlock(block);
//   const closeEditModal = () => setEditingBlock(null);

//   const handleDragEnd = ({ active, over }) => {
//     if (!over) return;

//     // ---------- SORTING ----------
//     const oldIndex = blocks.findIndex((b) => b.key === active.id);
//     const newIndex = blocks.findIndex((b) => b.key === over.id);

//     if (oldIndex !== -1 && newIndex !== -1 && oldIndex !== newIndex) {
//       setBlocks((items) => arrayMove(items, oldIndex, newIndex));
//       return;
//     }

//     // ---------- ADDING (ONLY from palette → canvas) ----------
//     if (over.id !== "canvas") return;

//     const item = initialItems.find((i) => i.id === active.id);
//     if (!item) return;

//     setBlocks((prev) => [
//       ...prev,
//       {
//         key: `${item.id}-${crypto.randomUUID()}`,
//         type: item.type,
//         title: item.title,
//         icon: item.icon,
//         content: "",
//         settings: {}, // 🔥 modal data lives here
//       },
//     ]);
//   };

//   // ----- Remove Block -----
//   const removeBlock = (key) => {
//     setBlocks((prev) => prev.filter((b) => b.key !== key));
//   };

//   // ----- Save from modal -----
//   const saveBlockProperties = (updatedBlock, finalize = true) => {
//     setBlocks((prev) =>
//       prev.map((b) => (b.key === updatedBlock.key ? updatedBlock : b)),
//     );
//     if (finalize) closeEditModal();
//     else setEditingBlock(updatedBlock);
//   };

//   const submit = async (data) => {
//     const myData = { id: state ? state?.id : 0 };

//     const payload = blocks.map(({ key, type, title, content, ...rest }) => ({
//       key,
//       type,
//       title,
//       content,
//       ...rest,
//     }));
//     console.log("Final Payload:", payload);

//     console.log("Form data:", myData);
//     // console.log("converted data:", convertedData);

//     // try {
//     //   if (state) {
//     //     await FieldSetsAPI.post(myData);
//     //     toast.success("FieldSets Updated Successfully", {
//     //       position: customSettings.toastPosition,
//     //       autoClose: customSettings.toastClose,
//     //     });
//     //   } else {
//     //     await FieldSetsAPI.post(myData);
//     //     toast.success("FieldSets Created Successfully", {
//     //       position: customSettings.toastPosition,
//     //       autoClose: customSettings.toastClose,
//     //     });
//     //   }

//     //   // ------- Get all object keys form data and set empty values to reset ------------
//     //   const keys = Object.keys(data);
//     //   for (const key of keys) {
//     //     submittedValues[key] = "";
//     //   }
//     //   reset({ ...submittedValues });
//     //   navigate(-1);
//     // } catch (error) {
//     //   toast.error("Something Went Wrong", {
//     //     position: customSettings.toastPosition,
//     //     autoClose: customSettings.toastClose,
//     //   });
//     //   console.log(error);
//     // }
//   };

//   return (
//     <>
//       <form onSubmit={handleSubmit(submit)}>
//         <Card>
// <Card.Header className="border-bottom">
//   <Row className="flex-between-center">
//     <Col md>
//       <BreadCrumbTable
//         title="Shopenze"
//         subTitle="Home Page"
//         subSubTitle={state?.name}
//       />
//     </Col>
//     <Col xs="auto" style={{ paddingRight: "12px" }}>
//       <Button
//         variant="link"
//         className="text-secondary fw-medium p-0 me-3"
//         type="button"
//         onClick={() => navigate(-1)}
//       >
//         Cancel
//       </Button>
//       <Button variant="primary" type="submit">
//         Ok
//       </Button>
//     </Col>
//   </Row>
// </Card.Header>

// <div
//   className="d-flex justify-content-between align-items-center my-2"
//   style={{
//     padding: "0px 20px",
//   }}
// >
//   <div
//     className="py-2 px-2 fw-bold"
//     style={{
//       width: "83%",
//       background: "#f8fafc",
//       borderTopLeftRadius: 5,
//       borderBottomLeftRadius: 5,
//       border: "1px solid #e5e7eb",
//       borderRight: 0,
//     }}
//   >
//     Home Page - Design
//   </div>
//   <div
//     className="py-2 px-2 fw-bold"
//     style={{
//       width: "17%",
//       background: "#f8fafc",
//       borderTopRightRadius: 5,
//       borderBottomRightRadius: 5,
//       border: "1px solid #e5e7eb",
//       borderLeft: 0,
//     }}
//   >
//     Tools
//   </div>
// </div>

//           <DndContext onDragEnd={handleDragEnd}>
//             <div
// className="d-flex gap-3"
// style={{
//   padding: "0px 20px",
// }}
//             >
//               {/* CANVAS */}
//               <div style={{ width: "83%" }}>
//                 <Droppable>
//                   <SortableContext
//                     items={blocks.map((b) => b.key)}
//                     strategy={rectSortingStrategy}
//                   >
//                     <div
//                       style={{
//                         marginBottom: "30px",
//                         // display: "grid",
//                         // gridTemplateColumns:
//                         //   "repeat(auto-fill, minmax(240px,1fr))",
//                         // gap: "16px",
//                       }}
//                     >
//                       {blocks.map((block) => (
//                         <SortableItem
//                           key={block.key}
//                           id={block.key}
//                           field={block}
//                           onDelete={removeBlock}
//                           handleSetting={setEditingBlock}
//                         >
//                           {block.type === "container" ? (
//                             <ContainerBlock title={block.content} />
//                           ) : (
//                             <FieldBlock field={block} />
//                           )}
//                         </SortableItem>
//                       ))}
//                     </div>
//                   </SortableContext>
//                 </Droppable>
//               </div>

//               {/* MODULES */}
//               <div
//                 style={{
//                   width: "17%",
//                   border: "1px solid #e5e7eb",
//                   borderRadius: "5px",
//                   background: "#fff",
//                 }}
//               >
//                 {initialItems?.map((item) => (
//                   <Draggable key={item.id} item={item} />
//                 ))}
//               </div>
//             </div>
//           </DndContext>
//         </Card>
//       </form>

//       <BlockEditModal
//         show={!!editingBlock}
//         block={editingBlock}
//         onClose={closeEditModal}
//         onSave={saveBlockProperties}
//       />
//       <MarqueeMessageModal
//         show={!!editingBlock}
//         block={editingBlock}
//         onClose={closeEditModal}
//         onSave={saveBlockProperties}
//       />
//     </>
//   );
// };

// export default PageBuilder;

import { DndContext } from "@dnd-kit/core";
import {
  SortableContext,
  rectSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import { useState } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";

import { initialItems } from "../helpers/initialItems";
import Draggable from "../helpers/Draggable";
import Droppable from "../helpers/Droppable";
import SortableItem from "../helpers/SortableItem";
import MarqueeMessageModal from "../modal/MarqueeMessageModal";
import SliderModal from "../modal/SliderModal";
import CategoriesWithIconsModal from "../modal/CategoriesWithIconsModal";
import CategoriesGroupBannersModal from "../modal/CategoriesGroupBannersModal";
import ContentPageModal from "../modal/ContentPageModal";
import HeaderMenusModal from "../modal/HeaderMenusModal";
import ProductsModal from "../modal/ProductsModal";
import FooterCopyRightsModal from "../modal/FooterCopyRightsModal";
import LogoAndStandardEcomOptionsModal from "../modal/LogoAndStandardEcomOptionsModal";
import CatGroupWithSocialMediaIconWithTextAndLogo from "../modal/CatGroupWithSocialMediaIconWithTextAndLogo";
import BreadCrumbTable from "../../../../components/breadcrumb/BreadCrumbTable";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const MODAL_MAP = {
  marqueeMessages: MarqueeMessageModal,
  text_Logo_CategoryGroups_SocialMediaIcons:
    CatGroupWithSocialMediaIconWithTextAndLogo,
  logo_Standard_ECommerce_Opions: LogoAndStandardEcomOptionsModal,
  slider: SliderModal,
  categories_with_icons: CategoriesWithIconsModal,
  category_Groups_Banner: CategoriesGroupBannersModal,
  content_Page: ContentPageModal,
  header_menus: HeaderMenusModal,
  products: ProductsModal,
  footerCopyrights: FooterCopyRightsModal,
};

const PageBuilder = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [blocks, setBlocks] = useState([]);
  const [editingBlock, setEditingBlock] = useState(null);

  // const handleDragEnd = ({ active, over }) => {
  //   if (!over) return;

  //   const oldIndex = blocks.findIndex((b) => b.key === active.id);
  //   const newIndex = blocks.findIndex((b) => b.key === over.id);

  //   if (oldIndex !== -1 && newIndex !== -1) {
  //     setBlocks((items) => arrayMove(items, oldIndex, newIndex));
  //     return;
  //   }

  //   if (over.id !== "canvas") return;

  //   const item = initialItems.find((i) => i.id === active.id);
  //   if (!item) return;

  //   setBlocks((prev) => [
  //     ...prev,
  //     {
  //       key: `${item.id}-${crypto.randomUUID()}`,
  //       type: item.type,
  //       title: item.title,
  //       icon: item.icon,
  //       settings: {},
  //     },
  //   ]);
  // };

  const handleDragEnd = ({ active, over }) => {
    if (!over) return;

    const oldIndex = blocks.findIndex((b) => b.key === active.id);
    const newIndex = blocks.findIndex((b) => b.key === over.id);

    if (oldIndex !== -1 && newIndex !== -1) {
      setBlocks((items) => arrayMove(items, oldIndex, newIndex));
      return;
    }

    if (over.id !== "canvas") return;

    const item = initialItems.find((i) => i.id === active.id);
    if (!item) return;

    setBlocks((prev) => [
      ...prev,
      {
        key: `${item.id}-${crypto.randomUUID()}`,
        type: item.id, // 🔥 IMPORTANT
        title: item.title,
        icon: item.icon,
        settings: {},
      },
    ]);
  };

  // const saveBlockProperties = (updatedBlock) => {
  //   setBlocks((prev) =>
  //     prev.map((b) => (b.key === updatedBlock.key ? updatedBlock : b)),
  //   );
  //   setEditingBlock(null);
  // };

  const updateBlockSettings = (settings) => {
    setBlocks((prev) =>
      prev.map((b) => (b.key === editingBlock.key ? { ...b, settings } : b)),
    );
  };

  const ActiveModal = MODAL_MAP[editingBlock?.type];

  const submit = () => {
    const payload = {
      blocks: blocks.map(({ key, type, title, settings }) => ({
        key,
        type,
        title,
        settings,
      })),
    };

    // console.log("FINAL PAYLOAD", payload);
  };

  return (
    <>
      <Card>
        <Card.Header className="border-bottom">
          <Row className="flex-between-center">
            <Col md>
              <BreadCrumbTable
                title="Shopenze"
                subTitle="Home Page"
                subSubTitle={state?.name}
              />
            </Col>
            <Col xs="auto" style={{ paddingRight: "12px" }}>
              <Button
                variant="link"
                className="text-secondary fw-medium p-0 me-3"
                type="button"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={submit}>
                Ok
              </Button>
            </Col>
          </Row>
        </Card.Header>

        <div
          className="d-flex justify-content-between align-items-center my-2"
          style={{
            padding: "0px 20px",
          }}
        >
          <div
            className="py-2 px-2 fw-bold"
            style={{
              width: "83%",
              background: "#f8fafc",
              borderTopLeftRadius: 5,
              borderBottomLeftRadius: 5,
              border: "1px solid #e5e7eb",
              borderRight: 0,
            }}
          >
            Home Page - Design
          </div>
          <div
            className="py-2 px-2 fw-bold"
            style={{
              width: "17%",
              background: "#f8fafc",
              borderTopRightRadius: 5,
              borderBottomRightRadius: 5,
              border: "1px solid #e5e7eb",
              borderLeft: 0,
            }}
          >
            Tools
          </div>
        </div>

        <DndContext onDragEnd={handleDragEnd}>
          <div
            className="d-flex gap-3"
            style={{
              padding: "0px 20px",
            }}
          >
            <div style={{ width: "83%" }}>
              <Droppable>
                <SortableContext
                  items={blocks.map((b) => b.key)}
                  strategy={rectSortingStrategy}
                >
                  {blocks.map((block) => (
                    <SortableItem
                      key={block.key}
                      id={block.key}
                      field={block}
                      onDelete={(id) =>
                        setBlocks((prev) => prev.filter((b) => b.key !== id))
                      }
                      onEdit={setEditingBlock}
                    >
                      <strong>{block.title}</strong>
                      {/* <pre>{JSON.stringify(block.settings, null, 2)}</pre> */}
                    </SortableItem>
                  ))}
                </SortableContext>
              </Droppable>
            </div>

            <div
              style={{
                width: "17%",
                border: "1px solid #e5e7eb",
                borderRadius: "5px",
                background: "#fff",
              }}
            >
              {initialItems.map((item) => (
                <Draggable key={item.id} item={item} />
              ))}
            </div>
          </div>
        </DndContext>
      </Card>

      {ActiveModal && (
        <ActiveModal
          show
          block={editingBlock}
          onChange={updateBlockSettings}
          onClose={() => setEditingBlock(null)}
        />
      )}
    </>
  );
};

export default PageBuilder;
